/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { loadScoringGrids, loadDimensionPeriods } from "../../actionCreators";
import { getScoringGrids, getDimensionPeriods } from "../../selectors";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import ScoringComponent from "./ScoringComponent";

export const ScoringContainer = ({ partnerId, actions, scoringGridLoaded, scoringGrid, dimensionPeriods }) => {
  const [cardExpanded, setExpanded] = useState(false);

  const onExpand = expanded => {
    if (cardExpanded !== expanded) setExpanded(expanded);
  };

  const loadData = () => {
    actions.loadScoringGrids(partnerId);
  };

  useEffect(() => {
    loadData();
  }, []);

  useEffect(() => {
    if (scoringGridLoaded) loadData();
  }, [scoringGridLoaded]);

  useEffect(() => {
    actions.loadDimensionPeriods();
  }, []);

  return (
    <ScoringComponent
      scoringGridLoaded={scoringGridLoaded}
      scoringGrid={scoringGrid}
      dimensionPeriods={dimensionPeriods}
      scoringGridExpanded={cardExpanded}
      onScoringGridExpand={onExpand}
    />
  );
};

ScoringContainer.propTypes = {
  partnerId: PropTypes.number,
  actions: PropTypes.object.isRequired,
  scoringGridLoaded: PropTypes.bool,
  scoringGrid: PropTypes.object,
  dimensionPeriods: PropTypes.array.isRequired
};

function mapStateToProps(state, ownProps) {
  const {
    content: scoringGrid,
    loaded: scoringGridLoaded,
    loading: scoringGridLoading
  } = getScoringGrids(state, ownProps.partnerId);

  return {
    scoringGrid,
    scoringGridLoaded,
    scoringGridLoading,
    dimensionPeriods: getDimensionPeriods(state)
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ loadScoringGrids, loadDimensionPeriods }, dispatch),
    dispatch
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ScoringContainer);
